// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"6b4440f0","628":"ed6e0020"}[chunkId] + ".chunk.js";
};